import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { openSidebar, openScreen } from '@slices/uiSlice'
import { useActiveJackpot } from './useActiveJackpot'

// Ports defenderV2's JackpotBar text<->percentage toggle timers (5s each)
// so JackpotBarModule stays pure render.
const TOGGLE_DURATION_MS = 5000

export const useJackpotBar = () => {
  const dispatch = useDispatch()
  const { jackpot, isActive } = useActiveJackpot()
  const [showText, setShowText] = useState(true)
  const [animationKey, setAnimationKey] = useState(0)

  useEffect(() => {
    if (!isActive) return
    const timer = setTimeout(() => {
      setShowText((prev) => !prev)
      setAnimationKey((key) => key + 1)
    }, TOGGLE_DURATION_MS)
    return () => clearTimeout(timer)
  }, [isActive, showText])

  const fillPercentage = Math.min(100, parseFloat(jackpot?.filled || 0))

  // Opens the sidebar directly to the Jackpot screen — same destination as
  // the burger-menu Jackpot option (Menu.jsx), just a second entry point.
  const onOpen = () => {
    dispatch(openSidebar())
    dispatch(openScreen({ key: 'jackpot', title: 'Jackpot', screen: 'JACKPOT' }))
  }

  return { isVisible: isActive, showText, fillPercentage, animationKey, onOpen }
}
